<template>
	<section
		class="container container--a margin-module"
		:class="data.custom_form_title_descrription ? 'custom-info' : ''"
	>
		<div class="inner">
			<div class="header">
				<h2 v-if="data.custom_form_title_descrription" class="titler">{{ data.form_title }}</h2>
				<div v-if="data.custom_form_title_descrription" class="description">{{ data.form_description }}</div>
			</div>
			<div class="content form-wrap" ref="content" v-once><Preloader /></div>
		</div>
	</section>
</template>

<script>
import { mapActions } from 'vuex'
import Preloader from '@/components/elements/Preloader'

export default {
	name: 'form-picker',
	props: ['data'],
	mounted() {
		const content = this.$refs.content
		const formId = this.data.form_id
		if (formId) {
			this.loadGravityForm2(formId, content)
		}
	},
	components: {
		Preloader,
	},
	methods: {
		...mapActions([
			// 'loadGravityForm'
		]),
		loadGravityForm2(formId, content) {
			const apiUrl = window.WPVUE.home.replace(/\/$/, '') + '/' + window.WPVUE.ajaxurl
			return window.axios
				.get(apiUrl, {
					params: {
						action: 'gf_button_get_form',
						form_id: formId,
						nonce: process.env.NODE_ENV === 'production' ? window.WPVUE.nonce : 'dev2$TF@qw',
					},
				})
				.then((res) => {
					if (typeof window['gformInitDatepicker'] !== 'undefined') {
						window.gformInitDatepicker()
					}
					if (content) {
						window.jQuery(content).html(res.data)
					}
					return res
				})
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';

body.theme {
	&-blue {
		.module-form_picker {
			&.custom-info {
				.header {
					background-color: var(--blueLight);
					color: var(--blue);
				}
			}
		}
	}
	&-red {
		.module-form_picker {
			&.custom-info {
				.header {
					background-color: var(--redLight);
					color: var(--red);
				}
			}
		}
	}
	&-green {
		.module-form_picker {
			&.custom-info {
				.header {
					background-color: var(--greenLight);
					color: var(--green);
				}
			}
		}
	}
	&-purple {
		.module-form_picker {
			&.custom-info {
				.header {
					background-color: var(--purpleLight);
					color: var(--purple);
				}
			}
		}
	}
}
.module-form_picker {
	&.custom-info {
		.header {
			padding: 75px;
			background-color: var(--gray);
			border-top-left-radius: $radius;
			border-top-right-radius: $radius;
			padding-bottom: 20px !important;
			@include mquery($tablet) {
				padding: 50px;
			}
			@include mquery($tablet) {
				padding: 25px;
			}
		}
		.gform_wrapper {
			padding-top: 0 !important;
			border-top-left-radius: 0;
			border-top-right-radius: 0;
		}
		.gform_heading {
			display: none;
		}
	}
	.titler {
		margin-top: 0;
		margin-bottom: 30px;
	}
}
</style>
